module.exports = __webpack_public_path__ + "img/trust_banner.ad5217ba.png";